<h2>
  <app-grid-quick-filter
    style="width: 350px"
    class="pull-right"
    [filterTypes]="quickFilters"
  ></app-grid-quick-filter>
  Claim Inventory
</h2>
<hr />
<div class="claimsContainer">
  <div id="claim-grid" class="row">
    <div class="col-md-12">
      <app-grid-wrapper
        #grid
        [selectRowOnCellClick]="true"
        persistenceKey="claimsList"
        [autoHeight]="false"
      >
        <div class="row">
          <div class="col-md-12">
            <button type="button" class="btn btn-default" (click)="refresh()">Refresh</button>
          </div>
        </div>
      </app-grid-wrapper>
    </div>
  </div>

  <div class="panel panel-default stick" *ngIf="model">
    <div class="panel-body">
      <div class="row">
        <ng-container *ngFor="let def of detailViewColumns">
          <ng-container *ngIf="def.headerName">
            <div class="col-xs-6 col-sm-4 col-md-3">
              <span class="itemLabel">{{ def.headerName }}:</span>
              <span
                class="itemValue"
                *ngIf="!def.cellRenderer"
                title="{{ def.toolTip ? model[def.toolTip] : '' }}"
                >{{ model[def.field] }}</span
              >
              <span
                class="itemValue"
                *ngIf="def.cellRenderer"
                [innerHTML]="def.cellRenderer(model)"
              ></span>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <hr class="thin" />

      <div class="row button-row col-md-12 text-center">
        <div class="btn-group" [ngClass]="{ hidden: !model }">
          <button
            type="button"
            class="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Update
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu">
            <li (click)="showClaimAdjustedReceivedDateModal()">
              <a href="javascript:void(0)">Received date</a>
            </li>
            <li (click)="showClaimDeleteModal()">
              <a href="javascript:void(0)">Delete</a>
            </li>
          </ul>
        </div>
        <button
          type="button"
          class="btn btn-default"
          [ngClass]="{ 'btn-primary': isProgressViewShown }"
          (click)="toggleProcessingProgress()"
        >
          Processing Progress
        </button>
        <button
          type="button"
          class="btn btn-default"
          [ngClass]="{ 'btn-primary': isExportViewShown }"
          (click)="toggleEncounterConfigComparison()"
        >
          Encounter Config Comparison
        </button>
        <button
          type="button"
          class="btn btn-default"
          [ngClass]="{ 'btn-primary': isX12ViewShown }"
          (click)="showSummaryConfigComparison()"
        >
          EDI Comparison
        </button>
        <!-- <button type="button" class="btn btn-default" [ngClass]="{'btn-primary':isAuditView}" (click)="showAuditDetail()">Audit Detail</button> -->
        <button
          type="button"
          class="btn btn-default"
          [ngClass]="{ 'btn-primary': isCodesView }"
          (click)="showCodesView()"
        >
          Response Codes
        </button>

        <div class="btn-group" [ngClass]="{ hidden: !model }">
          <button
            type="button"
            class="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            [disabled]="!model.AvailableActions || model.AvailableActions.length === 0"
          >
            Actions
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu">
            <li *ngFor="let action of model.AvailableActions" (click)="performAction(action)">
              <a href="javascript:void(0)">{{ action.ActionName }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div id="claim-progress-grid" class="row" [ngClass]="{ hidden: !model || !isProgressViewShown }">
    <div class="col-md-12">
      <div class="panel panel-default" style="display: flex; flex-direction: column">
        <div class="panel-heading" style="flex-shrink: 0; display: flex; align-items: center; justify-content: space-between">
          <button class="btn btn-default" (click)="closePanels()">
            Close Processing Progress
            <span
              aria-hidden="true"
              style="
                font-size: 24px;
                line-height: 16px;
                vertical-align: text-bottom;
                font-weight: bold;
              "
              >&times;</span
            >
          </button>
          <span *ngIf="progressLastRun" style="color: #666; font-size: 12px">
            Last run: {{ formattedLastRun }} ({{ userTimezone }})
          </span>
        </div>
        <div class="panel-body" style="overflow-y: auto; padding: 0; flex: 1 1 auto">
          <p-table
            #progressTable
            [value]="progressSteps"
            dataKey="stepName"
            [expandedRowKeys]="expandedRows"
            [scrollable]="true" 
            scrollHeight="500px"
            [tableStyle]="{ 'min-width': '60rem', 'table-layout': 'fixed' }"
            styleClass="p-datatable-sm p-datatable-striped"
          >
            <ng-template pTemplate="header">
              <tr style="z-index: 1; background: #f5f5f5">
                <th style="width: 3rem;"></th>
                <th style="width: 8rem;">Status</th>
                <th>Validation</th>
                <th>Message</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-step let-expanded="expanded">
              <tr
                (click)="step.fields?.length ? toggleRowIfNotSelecting(step, $event) : null"
                [style.cursor]="step.fields?.length ? 'pointer' : 'default'"
              >
                <td>
                  <i *ngIf="step.fields?.length" [class]="expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                </td>
                <td>
                  <span [style.color]="getStatusColor(step.status)" style="font-weight: bold">
                    {{ step.status }}
                  </span>
                </td>
                <td>{{ step.stepName }}</td>
                <td>{{ step.shortMessage }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="expandedrow" let-step>
              <tr>
                <td colspan="4" style="padding: 0.5rem 1rem 0.5rem 4rem">
                  <div style="display: inline-block">
                    <div *ngIf="step.message && step.status === 'Failed'" style="margin-bottom: 0.5rem">
                      <strong>Message:</strong> {{ step.message }}
                    </div>
                    <table *ngIf="step.fields && step.fields.length" class="table table-sm table-bordered mb-0" style="width: auto; margin-bottom: 0">
                      <thead>
                        <tr>
                          <th>Field</th>
                          <th>Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let field of step.fields">
                          <td>{{ field.name }}</td>
                          <td>{{ field.value }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div *ngIf="!step.message && !(step.fields && step.fields.length)" style="color: #999; font-style: italic">
                      No additional details available.
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="4" style="text-align: center; padding: 1rem">No processing data found.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>

  <div id="claim-export-grid" class="row" [hidden]="!model || !isExportViewShown">
    <div class="col-md-12">
      <app-grid-wrapper
        #gridExport
        (cellValueChanged)="configFieldChanged($event)"
        [autoHeight]="false"
      >
        <button class="btn btn-default" (click)="closePanels()">
          Close Encounter Config Comparison
          <span
            aria-hidden="true"
            style="
              font-size: 24px;
              line-height: 16px;
              vertical-align: text-bottom;
              font-weight: bold;
            "
            >&times;</span
          >
        </button>
      </app-grid-wrapper>
    </div>
  </div>

  <div id="claim-x12-comparison" class="row" [hidden]="!model || !isX12ViewShown">
    <div class="col-md-12">
      <div class="panel panel-default">
        <div class="panel-heading">
          <div class="row">
            <div class="col-md-8">
              <button class="btn btn-default" (click)="closeX12View()">
                Close EDI Comparison
                <span
                  aria-hidden="true"
                  style="
                    font-size: 24px;
                    line-height: 16px;
                    vertical-align: text-bottom;
                    font-weight: bold;
                  "
                  >&times;</span
                >
              </button>
            </div>
            <div class="col-md-2">
              <button class="btn btn-default" (click)="gotoDiff(-1)" [disabled]="currentDiff <= 1">
                Previous
              </button>
              <button
                class="btn btn-default"
                (click)="gotoDiff(1)"
                [disabled]="currentDiff >= differences"
              >
                Next
              </button>
            </div>
            <div class="col-md-2" style="padding: 7px">
              {{ differences }} differences were found
            </div>
          </div>
        </div>
        <div class="panel-body" style="padding: 0">
          <div class="row">
            <div class="col-md-12">
              <app-diff
                #diff
                [resultid]="'claim-x12-comparison-result'"
                [hasHeader]="true"
                [leftHeader]="'837 In'"
                [rightHeader]="'837 Out'"
                [compareHeader]="'EDI Comparison'"
              ></app-diff>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-audit-detail
    id="claim-auditDetail-grid"
    #auditDetail
    [hidden]="!model || !isAuditView"
    (closeClicked)="closeAuditView()"
  ></app-audit-detail>

  <div id="codes" class="panel panel-default" [hidden]="!model || !isCodesView">
    <div class="panel-heading">
      <div class="row">
        <div class="col-md-8">
          <button class="btn btn-default" (click)="closeCodesView()">
            Close Response Codes
            <span
              aria-hidden="true"
              style="
                font-size: 24px;
                line-height: 16px;
                vertical-align: text-bottom;
                font-weight: bold;
              "
              >&times;</span
            >
          </button>
        </div>
      </div>
    </div>
    <div class="panel-body">
      <div class="well">
        <app-response-codes-claim-line-adjustment-reasons
          *ngIf="model && isCodesView"
          [claimLineView]="model"
          (alertMessage)="toastr.error($event)"
        ></app-response-codes-claim-line-adjustment-reasons>
      </div>
      <app-response-codes-remittance-remarks
        *ngIf="model && isCodesView"
        [claimLineView]="model"
      ></app-response-codes-remittance-remarks>
    </div>
  </div>
</div>
